import React from 'react';
import Panel from '../Panel';
import CopySection, { FinishStepButton } from '../CopySection';
import styles from './AddWorkspaceMembersPanel.module.scss';
import { WorkspaceMemberManager } from '@views/Settings/panels/WorkspaceMembers';

export default function AddWorkspaceMembersPanel({
  proceedToNextStep,
}: {
  proceedToNextStep: () => void;
}) {
  return (
    <Panel>
      <CopySection>
        <h2>Invite your team members</h2>
        <p>
          Get the most out of Clay by inviting your team members. You can start by inviting 2 of
          your teammates. You can always invite more in Settings later!
        </p>
        <FinishStepButton onClick={proceedToNextStep}>Continue</FinishStepButton>
      </CopySection>
      <WorkspaceMemberManager
        className={styles.membersSettings}
        optionsClassName={styles.options}
        showDisabledAddMemberBtn
        canRenderUpgradeMsg={false}
        confirmMemberRemovals={false}
      />
    </Panel>
  );
}
